import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import StaticContext from '~/context/common/StaticContext';
import TradeContext from '~/context/common/TradeContext';
import fetchAcquisitionSummaries from '~/services/common/fetchAcquisitionSummaries';
import { generateErrorLogger } from '~/utilities/loggers';

export default function useGetTrades(isLoggedIn: boolean) {
  const {
    trades: { setLoading, setData, setError }
  } = useContext(TradeContext);
  const { eventCorrelationId } = useContext(StaticContext);

  useSubsequentEffect(() => {
    if (!isLoggedIn) return;

    setLoading();
    fetchAcquisitionSummaries(eventCorrelationId)
      .then(t => setData(t))
      .catch(generateErrorLogger('Get trades', {}, { callback: setError }));
  }, [eventCorrelationId, isLoggedIn, setData, setError, setLoading]);
}
